import { handleScheduledDateChange } from "@/assignments/utils/assignmentActions";
import { getLiteContentWithEarliestExpireDate } from "@/assignments/utils/assignmentUtils";
import useExpirationWarning from "@/assignments/utils/useExpirationWarning";
import ArticleLevel from "@/types/models/ArticleLevel.interface";
import { Assignment } from "@/types/models/Assignment.interface";
import { UserProperties } from "@/types/models/UserProperties.interface";
import ScheduleInput from "@/view/AdditionalAssignmentSettings/AssignmentBuilderAdditionalSettings/ScheduleInput";

const ScheduledInput = ({
  assignment,
  content,
  dispatch,
  resetDate,
  userProperties,
}: {
  assignment: Assignment;
  content: {
    data: {
      article_levels: ArticleLevel[];
    };
    id: string;
    is_lite: boolean;
  };
  dispatch: () => void;
  resetDate: string | null;
  userProperties: UserProperties;
}) => {
  const onScheduledDateTimeChange = (datetime: string) => {
    handleScheduledDateChange(datetime, dispatch);
  };

  // handle expiration date toast display for lite users
  const liteContentWithEarliestExpireDate =
    getLiteContentWithEarliestExpireDate([content?.data]);
  useExpirationWarning(liteContentWithEarliestExpireDate);

  // determine the maximum date that the assignment can be scheduled
  const maxScheduleDate =
    userProperties?.isLiteUser &&
    liteContentWithEarliestExpireDate?.date_lite_product_grant_expires;
  return (
    <>
      <ScheduleInput
        onChange={(date) => onScheduledDateTimeChange(date)}
        dateGoesLive={assignment?.date_goes_live || resetDate}
        originalDateGoesLive={resetDate}
        maxScheduleDate={maxScheduleDate}
      />
    </>
  );
};

export default ScheduledInput;
